export const styles = {
  accordion: {
    marginBottom: '1rem',
    marginRight: '1rem',
  },
  svgIcon: {
    width: 32,
    height: 38,
  },
  fileName: {
    fontSize: '1rem',
    fontWeight: 600,
  },
  fileDescription: {
    fontSize: '0.75rem',
    fontWeight: 400,
    maxWidth: '40rem',
  },
  fileList: {
    paddingTop: 0,
  },
  fileItem: {
    padding: 0,
  },
  fileLink: {
    fontSize: '0.75rem',
    fontWeight: 400,
    color: '#037DE8',
  },
  uploadButton: {
    fontSize: '0.75rem',
    fontWeight: 700,
    padding: 0,
    margin: 0,
  },
  hiddenInput: {
    display: 'none',
  },
  progressBar: {
    marginTop: '1rem',
  },
};
